<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div class="add-to-portfolio">
        <Portal v-if="instruments" to="breadcrumb_addCompanyPageInstrumentToPortfolio">
          Zu Portfolio hinzufügen
        </Portal>

        <fin-add-to-portfolio :action="action"
                              :instruments="instruments"
                              :portfolioId="portfolioId"
                              :title="title"
                              :to="to"/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinAddToPortfolio from '@/components/common/portfolio/AddToPortfolio/index'
import FinDataLoader from "@/components/common/DataLoader"
import {finPortfolioAPI, finShareAPI} from "@/js/finAPI"

export default {
  name: 'fin-company-page-add-to-portfolio',
  components: {
    FinDataLoader,
    FinAddToPortfolio
  },
  props: {
    id: {
      type: String
    },
    action: {
      type: String
    },
    portfolioId: {
      type: String
    },
    assetClassId: {
      type: String
    }
  },
  data() {
    return {
      instruments: [],
      to: null,
      title: null,
    }
  },
  methods: {
    async loadData() {
      // TODO could pass instruments when coming from portfolio so we dont have to use getPortfolio here
      // coming from portfolio
      if (this.portfolioId) {
        const result = await finPortfolioAPI.getPortfolio(this.portfolioId)
        const shares = result.shareEntries.items
        let shareById = shares.find(e => e.instrument.id === this.id)
        this.instruments = [shareById.instrument]

        this.to = {name: 'portfolioDetail', params: {id: this.portfolioId, tab: this.tab}}
      }
      // coming from company page -> read share/etf by id
      else if (this.id) {
        let result = []

        this.to = {name: 'companyDetail', params: {id: this.id}}
        result.push(await finShareAPI.getMinimalShare(this.id))
        this.title = 'Wertpapier in Portfolio hinzufügen'

        this.instruments = result
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-portfolio {
  background-color: #fff;
}
</style>
